import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { submitOrderToCanada } from 'actions/orders';
import TextField from 'components/TextField';
import Button from '@material-ui/core/Button';
import Select from 'components/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getCountries } from 'actions/countries';
import { updateStaplesOrder } from 'actions/orders';
import { getStaplesOrderXml } from 'pages/ipu/staplesOrderXml';
import {
  ProductModalFilter,
  SubTitleWrapper,
  SubTitle1,
  SubTitle2,
  ProductModalFields,
} from 'styles/pages/staples-bulk-orders';

const XMLParser = require('react-xml-parser');

const SaveToProductModal = ({ state, setState, reload }) => {
  const dispatch = useDispatch();
  const [modalState, setModalState] = useState({
    country: 'CA',
  });

  const auth = useSelector((state) => state?.auth);
  const token = useSelector((state) => state?.auth?.profile?.token);

  const handleClose = () =>
    setState({
      ...state,
      saveToProductionModal: false,
    });

  const countries = useSelector((state) => state?.countries?.data);
  const states = _.find(
    countries,
    (o) => o.code2 === modalState?.country
  )?.states;

  useEffect(() => {
    const loadCountries = async () => {
      if (!countries?.length) {
        dispatch(getCountries());
      }
    };
    loadCountries();
  }, [dispatch, countries]);

  useEffect(() => {
    const shipTo = state?.orderPdfData?.shipTo;
    const cityName = shipTo[shipTo?.length - 1].split(',')[0];
    setModalState({
      ...modalState,
      city: cityName,
    });
  }, [state]);

  const disabled =
    !modalState?.name ||
    !modalState?.addressLine1 ||
    !modalState.city ||
    !modalState.state ||
    !modalState?.country ||
    !modalState?.zipCode;

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={state?.saveToProductionModal}
      onClose={handleClose}
    >
      <DialogTitle>Submit To Production</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <ProductModalFilter>
            <SubTitleWrapper>
              <SubTitle1>Ship To</SubTitle1>
              {state?.orderPdfData?.shipTo?.map((o) => (
                <SubTitle2 style={{ lineHeight: '40px' }} key={o}>
                  {o}
                </SubTitle2>
              ))}
            </SubTitleWrapper>

            <SubTitleWrapper>
              <SubTitle1>Map Address</SubTitle1>
              <ProductModalFields>
                <TextField
                  size="small"
                  label="Name"
                  value={modalState?.name}
                  onChange={(v) =>
                    setModalState({
                      ...modalState,
                      name: v.trim(),
                    })
                  }
                />

                <div>
                  <TextField
                    size="small"
                    label="Address Line 1"
                    value={modalState?.addressLine1}
                    style={{ width: '48%', marginRight: '2%' }}
                    onChange={(v) =>
                      setModalState({
                        ...modalState,
                        addressLine1: v.trim(),
                      })
                    }
                  />

                  <TextField
                    size="small"
                    style={{ width: '50%' }}
                    label="Address Line 2"
                    value={modalState?.addressLine2}
                    onChange={(v) =>
                      setModalState({
                        ...modalState,
                        addressLine2: v.trim(),
                      })
                    }
                  />
                </div>

                <div>
                  <TextField
                    size="small"
                    label="City"
                    value={modalState?.city}
                    style={{ width: '48%', marginRight: '2%' }}
                    onChange={(v) =>
                      setModalState({
                        ...modalState,
                        city: v.trim(),
                      })
                    }
                  />

                  <TextField
                    size="small"
                    style={{ width: '50%' }}
                    label="Zip Code"
                    value={modalState?.zipCode}
                    onChange={(v) =>
                      setModalState({
                        ...modalState,
                        zipCode: v.trim(),
                      })
                    }
                  />
                </div>

                <div style={{ display: 'flex' }}>
                  <div style={{ width: '48%', marginRight: '2%' }}>
                    <Select
                      label="Country"
                      options={countries}
                      labelKey="name"
                      valueKey="code2"
                      value={{ code2: modalState?.country || '' }}
                      onChange={(c) => {
                        const states = _.find(
                          countries,
                          (o) => o.code2 === c
                        )?.states;

                        setModalState({
                          ...modalState,
                          country: c,
                          state: '',
                        });
                      }}
                    />
                  </div>
                  <div style={{ width: '50%' }}>
                    <Select
                      label="State/Province"
                      labelKey="name"
                      valueKey="code"
                      options={states}
                      value={{ code: modalState?.state || '' }}
                      onChange={(StateProvince) =>
                        setModalState({
                          ...modalState,
                          state: StateProvince,
                        })
                      }
                    />
                  </div>
                </div>
              </ProductModalFields>
            </SubTitleWrapper>
          </ProductModalFilter>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained">
          Close
        </Button>

        <Button
          // onClick={handleClose}
          color="primary"
          disabled={disabled}
          variant="contained"
          onClick={async () => {
            const payload = {
              po: Number(state?.orderPdfData?.orderPO[0]),
              shippingAddress: {
                name: modalState?.name,
                addressLine1: modalState?.addressLine1,
                addressLine2: modalState?.addressLine2,
                city: modalState.city,
                state: modalState.state,
                zipCode: modalState.zipCode,
                country: modalState?.country,
              },
            };
            let response = await dispatch(updateStaplesOrder(payload));

            setState({
              ...state,
              poSubmittedModalMessage: response?.message,
              poSubmitted: true,
              poSubmittedModalVisibility: true,
              saveToProductionModal: false,
            });

            const xml = getStaplesOrderXml(response);

            const submitOrderResponse = await dispatch(
              submitOrderToCanada(
                xml?.replaceAll('&', ' and ')?.replace(/>\s+</g, '><'),
                token
              )
            );

            const parseOrderResponse = new XMLParser().parseFromString(
              submitOrderResponse
            );

            const errorMessage =
              parseOrderResponse.getElementsByTagName('ErrorMessage');

            if (errorMessage?.length) {
              if (
                !!errorMessage[0]?.value?.trim()?.length &&
                errorMessage[0]?.value?.includes(
                  'already exists in the Database'
                )
              ) {
                alert(errorMessage[0].value);
                return;
              }
            }

            await dispatch(
              updateStaplesOrder({
                po: Number(state?.orderPdfData?.orderPO[0]),
                status: 'In-Production',
              })
            );

            setState({
              ...state,
              poSubmittedModalMessage: 'Order Submitted to Production',
              poSubmitted: true,
              poSubmittedModalVisibility: true,
            });

            reload();
          }}
        >
          Submit To Production
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveToProductModal;
